import styled from "styled-components/macro";

export const RelativeContainer = styled.div`
  position: relative;
  display: inline-block;
  min-width: 150px;
  max-width: 280px;
  background-color: var(--primary-cta);
  border-radius: 10px;
`;

export const AddBlankElementContainer = styled.div`
  --dropdown-button-width: 40px;

  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: none;
  color: var(--cta-text-color);
  border-radius: 10px;
  height: 40px;

  &.disabled {
    opacity: 0.5;

    .disabled {
      opacity: 1;
    }
  }

  &.nohover {
    .text-button-wrapper,
    .icon-button-wrapper {
      &:hover > div {
        background-color: transparent;
      }
    }
  }

  .text-button-wrapper {
    flex-grow: 1;
    box-sizing: border-box;
    height: 40px;

    &:first-child {
      border-right: solid 1px var(--slider-dot-active) !important;
      border-radius: 10px 0 0 10px !important;
    }
    &:last-child {
      border-radius: 0 10px 10px 0 !important;
    }

    &:focus-visible .text-button-inner {
      border-radius: 10px 0 0 10px;
    }

    .text-button-inner {
      padding: 0;
      padding-left: 10px;
      padding-right: 10px;
      border-radius: 10px 0 0 10px;
      height: 40px;
      font-size: 14px !important;
      justify-content: flex-start;
      gap: 9px;
      width: 100%;
    }
  }

  .icon-button-wrapper {
    height: 100%;
    flex-shrink: 0;
    width: var(--dropdown-button-width);
    border-radius: 0 10px 10px 0;

    &:hover > div {
      width: var(--dropdown-button-width);
    }

    &:active > div {
      width: var(--dropdown-button-width);
    }

    .icon-wrapper {
      height: 100%;
      width: var(--dropdown-button-width);
      border: none;
      border-radius: 0 10px 10px 0 !important;

      svg {
        width: 24px;
        height: 24px;

        path {
          fill: var(--cta-text-color);
        }
      }
    }
  }

  .text-button-wrapper,
  .icon-button-wrapper {
    display: flex;

    > div {
      color: var(--cta-text-color);
    }

    &:hover > div {
      background-color: var(--primary-cta-hover);
    }

    &:active > div {
      background-color: var(--primary-cta-active);
    }

    .text-button-inner,
    .icon-wrapper {
      font-weight: 500;
      line-height: 1.6em;
      font-family: Inter, sans-serif;

      svg {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        path {
          fill: var(--cta-text-color) !important;
        }
      }
    }
    &:focus-visible > div {
      background-color: var(--primary-cta-hover);
      
    }
  }
`;

export const OptionsContainer = styled.ul`
  position: absolute;
  list-style: none;
  background-color: var(--menu-color);
  border-radius: 10px;
  z-index: 3000;
  overflow: hidden auto;
  transition: all 0.3s ease-out;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  box-shadow: rgba(0, 0, 0, 0.15) 0 2px 6px;
  margin-top: 10px;

  li.option-item {
    button.option-item-button {
      cursor: pointer;
      padding: 0px;
      color: var(--grey-0) !important;
      border: none;
      padding: 10px 15px;
      font-family: Inter, sans-serif !important;
      background-color: var(--menu-color) !important;
      width: 100%;
      text-align: left;
      border-radius: 0 !important;
      font-weight: 500;

      &:hover {
        background-color: var(--menu-color-hover) !important;
      }

      &.selected {
        /* border: 2px solid var(--grey-2); */
      }
      &:focus-visible {
        outline: 2px solid var(--primary-cta);
        outline-offset: -2px;
      }
    }
  }
`;
